function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { composeEventName } from '../support/index';
import { StimulusUse } from '../stimulus_use';
var defaultOptions = {
  eventPrefix: true,
  bubbles: true,
  cancelable: true
};
export var UseDispatch = /*#__PURE__*/function (_StimulusUse) {
  _inherits(UseDispatch, _StimulusUse);

  var _super = _createSuper(UseDispatch);

  function UseDispatch(controller) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseDispatch);

    var _a, _b, _c, _d;

    _this = _super.call(this, controller, options);

    _this.dispatch = function (eventName) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _assertThisInitialize = _assertThisInitialized(_this),
          controller = _assertThisInitialize.controller,
          targetElement = _assertThisInitialize.targetElement,
          eventPrefix = _assertThisInitialize.eventPrefix,
          bubbles = _assertThisInitialize.bubbles,
          cancelable = _assertThisInitialize.cancelable,
          log = _assertThisInitialize.log; // includes the emitting controller in the event detail


      Object.assign(detail, {
        controller: controller
      });
      var eventNameWithPrefix = composeEventName(eventName, _this.controller, eventPrefix); // creates the custom event

      var event = new CustomEvent(eventNameWithPrefix, {
        detail: detail,
        bubbles: bubbles,
        cancelable: cancelable
      }); // dispatch the event from the given element or by default from the root element of the controller

      targetElement.dispatchEvent(event);
      log("dispatch", {
        eventName: eventNameWithPrefix,
        detail: detail,
        bubbles: bubbles,
        cancelable: cancelable
      });
      return event;
    };

    _this.targetElement = (_a = options.element) !== null && _a !== void 0 ? _a : controller.element;
    _this.eventPrefix = (_b = options.eventPrefix) !== null && _b !== void 0 ? _b : defaultOptions.eventPrefix;
    _this.bubbles = (_c = options.bubbles) !== null && _c !== void 0 ? _c : defaultOptions.bubbles;
    _this.cancelable = (_d = options.cancelable) !== null && _d !== void 0 ? _d : defaultOptions.cancelable;

    _this.enhanceController();

    return _this;
  }

  _createClass(UseDispatch, [{
    key: "enhanceController",
    value: function enhanceController() {
      Object.assign(this.controller, {
        dispatch: this.dispatch
      });
    }
  }]);

  return UseDispatch;
}(StimulusUse);
export var useDispatch = function useDispatch(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new UseDispatch(controller, options);
};